import { AuthState } from '@okta/okta-auth-js';

import { Whoami } from '../services/backend/Whoami';

import { useBaseApiClient } from './useBaseApiClient';

export const useWhoAmI: () => Whoami<AuthState> = () => {
  return useBaseApiClient(Whoami);
};
